import { Button } from '../../components/Button';
import { SkeletonBlock } from '../../components/SkeletonBlock';
import { StickyActionBar } from '../../components/StickyActionBar';
import { formatCurrency } from '../../utils/formatCurrency';
import {
  ActionBarArea,
  FooterLeft,
  FooterRow,
  FooterTitle,
  FooterTotal,
} from './PanelActionFooter.styles';
import type { PanelActionFooterProps } from './PanelActionFooter.types';

export function PanelActionFooter({
  title,
  totalLabel = 'Total',
  totalAmount,
  currencyCode,
  locale = 'en-GB',
  ctaLabel = 'Next',
  onCtaClick,
  ctaDisabled = false,
  isLoading = false,
}: PanelActionFooterProps) {
  return (
    <ActionBarArea>
      <StickyActionBar>
        <FooterRow>
          <FooterLeft>
            {isLoading ? (
              <>
                <SkeletonBlock width="140px" height="16px" />
                <SkeletonBlock width="90px" height="20px" />
              </>
            ) : (
              <>
                {title && <FooterTitle>{title}</FooterTitle>}
                <FooterTotal>
                  {totalLabel} {formatCurrency(totalAmount, currencyCode, { locale })}
                </FooterTotal>
              </>
            )}
          </FooterLeft>
          {isLoading ? (
            <SkeletonBlock width="96px" height="48px" borderRadius="24px" />
          ) : (
            <Button type="button" variant="primary" onClick={onCtaClick} disabled={ctaDisabled}>
              {ctaLabel}
            </Button>
          )}
        </FooterRow>
      </StickyActionBar>
    </ActionBarArea>
  );
}
